export default __webpack_public_path__ + "static/media/Documento.08e9316c.svg";